import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    template: `
    <select [(ngModel)]="selectedValue" (ngModelChange)="onValueChange()" class="custom-dropdown" *ngIf="varfield" >
                                <option *ngFor="let elem of dropdownOptions" [value]="elem.varreasonid">
                                    {{ elem.reason }}
                                </option>
                            </select>
     <select [(ngModel)]="selectedValue" (ngModelChange)="onValueChange()" class="custom-dropdown" *ngIf="arcfield">
                                <option *ngFor="let elem of dropdownOptions" [value]="elem.arcreasonid">
                                    {{ elem.reason }}
                                </option>
                            </select>
  `,
    styles: [
        `
        .custom-dropdown {
            width: 100% !important;
            min-width:90px !important;
            color :black;
            border: 1px solid black;

          }
    `
    ]
})
export class DropdownCellRenderer implements ICellRendererAngularComp {
    private params: any;
    selectedValue: any;
    dropdownOptions: any = [];
    varfield: boolean = false;
    arcfield: boolean = false

    agInit(params: any): void {
        this.params = params;
        // this.selectedValue =this.params.colDef.field == "varreasonid"?( (params.data?.varreasonid) ?params.data?.varreasonid:params.dropdownOptions[0].varreasonid):((params.data?.arcreasonid)?params.data?.arcreasonid:params.dropdownOptions[0].arcreasonid);
        this.selectedValue = params.value
        this.dropdownOptions = params.dropdownOptions;
        if (this.params.colDef.field == "varreasonid") {
            this.varfield = true
        }
        else if (this.params.colDef.field == "arcreasonid") {
            this.arcfield = true
        }
    }

    refresh(params: any): boolean {
        console.log("refresh", params)
        const rowNode = params.node;
        rowNode.data._edited = true;
        // if (rowNode) {
        //     if (params.newValue !== params.oldValue) {
        //         rowNode.data._edited = true;
        //     }
        // }
        return true;
    }

    onValueChange(): void {
        this.params.value = this.selectedValue;
        this.params.node.setDataValue(this.params.colDef.field, this.selectedValue);
    }
}
